import React from 'react'
import RichTextComponent from '../RichTextComponent/RichTextComponent'
import './LitlarMyndirOgTexti.scss'

export default function LitlarMyndirOgTexti(props) {
  const {
    slice,
    prismicCtx
  } = props

  return (
    <div className='litlarTexti__container'>
      <div className='litlarTexti__texti'>
        <RichTextComponent data={slice.primary.rich_text} prismicCtx={prismicCtx} />
      </div>
      <div className='litlarTexti__myndirContainer'>
        {slice.items.map((mynd, i) => (
          <div key={i} className='litlarTexti__myndContainer'>
            <img className='litlarTexti__mynd' src={mynd.mynd.url} alt={mynd.mynd.alt} />
          </div>
        ))}
      </div>
    </div>
  )
}